import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  UpdateStatus,
} from "../../../../../../../features/admin/website/home/why_choose_us/slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const whychooseUs = useSelector((state) => state?.website?.why_choose_us);

  console.log(whychooseUs, "whychooseUs");

  const [name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = whychooseUs?.current_page) => {
    await dispatch(
      GetAll({
        name: name,
        page: page,
        per_page: whychooseUs?.per_page,
      }),
    );
  };

  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  const toggleStatus = async (id) => {
    try {
      await dispatch(UpdateStatus(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    whychooseUs,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
  };
};
